import { render } from "./LoadingComponent.vue?vue&type=template&id=6a8f8964&scoped=true&ts=true"
import script from "./LoadingComponent.vue?vue&type=script&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&lang=ts"

import "./LoadingComponent.vue?vue&type=style&index=0&id=6a8f8964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8f8964"]])

export default __exports__